import { useEffect, useState } from "react"
import * as employerService from "../../src/services/employer-service"
import { SettingsResponse } from "../pages/settings/model";
import { UpdatePasswordRequest } from "../pages/settings-update/UpdatePasswordRequest";
import { CreateSessionResponse } from "../pages/settings/CreateSessionResponse";

export const useGetSettings = () => {
    const [settings, setSettings] = useState<SettingsResponse>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        employerService.getSettings().then((data: SettingsResponse) => {
            setSettings(data);
            setIsLoading(false);
        })
    }, []);

    return {settings, isLoading};
};

export const useUpdatePassword = () => {
    const [isLoading, setIsLoading] = useState(false);

    const updatePassword = async (updatePasswordRequest: UpdatePasswordRequest) => {
        setIsLoading(true);
        await employerService.updatePassword(updatePasswordRequest);
        setIsLoading(false);
    }

    return {updatePassword, isLoading};
};

export const useCreateSession = async (priceId?: string) => {

    const data = await employerService.createSession(priceId);

    return { data };
}